import React, { useState } from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"
import DragUploadInput from '../drag-upload-input/drag-upload-input'
import { CircularProgress } from '@mui/material'

import styles from './styles.module.css'

export const MediaUpload = ({ onClose, show }) => {
    const [validationError, setValidationError] = useState()
    const [inputValue, setInputValue] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    return (
        <Modal show={show} onClose={onClose}>
            <Card variant="modal" style={{ minWidth: 358 }}>
                <BaseForm onBack={onClose} title="Upload Media">
                    <div className={styles.textAreaContainer} style={{ marginTop: 20 }}>
                        {validationError?.message !== undefined && (
                            <div style={{ color: 'red', marginTop: 7, fontSize: 14, width: 345 }}>
                                {validationError?.message}
                            </div>
                        )}
                        <DragUploadInput
                            value={inputValue}
                            onChange={setInputValue}
                            accept=""
                            setValidationError={setValidationError}
                            setLoading={setIsLoading}
                        />
                    </div>
                    <div className={styles.actionGroup}>
                        <Button
                            onClick={onClose}
                            style={{ width: '100%' }}
                            variant="outline"
                            disabled={isLoading}
                        >
                            {
                                isLoading ? (
                                    <CircularProgress size={20} />
                                ) :
                                    (
                                        <>Finish</>
                                    )
                            }
                        </Button>
                    </div>
                </BaseForm>
            </Card>
        </Modal>
    )
}

export default (props) => props?.show ? <MediaUpload {...props}/> : null